import { MouseEvent } from 'react'
import { Box, Typography } from '@material-ui/core'
import styled from 'styled-components/macro'
import ReportDetailsMenuItem from './ReportDetailsMenuItem'
import { Modal } from 'components/core/modal/new-modal/Modal'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'
import { Button } from 'common/atoms/Button/Button'

const StyledActionsButton = styled(Button)`
  &&{
    border-radius: 0.625rem;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1rem;
  }
`

const StyledTakeActionsText = styled(Typography)`
  &&{
    color: ${({ theme }) => theme.colors.accent1};
    font-style: normal;
    font-weight: 400;
    font-size: 1.375rem;
    line-height: 1.375rem;
    margin-bottom: 30px;
    padding-left: 0.375rem;
  }
`

const ReportedDetailsMenu = () => {
  const { isOpen, setIsOpen, reportedContent } = ReportedContentState

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Box>
      <StyledActionsButton design='primary' onClick={handleClick}>
        Take Actions
      </StyledActionsButton>

      <Modal dialogWidth="lg" title="Take Actions" onClose={handleClose} show={isOpen} showCancel radius='20px' noBorder titleSize='2rem' margin='24px 24px 0px 24px' width='37.5rem'>
        <StyledTakeActionsText>
          Kindly select the action you would take
        </StyledTakeActionsText>

        <ReportDetailsMenuItem handleClose={handleClose}/>

      </Modal>
    </Box>
  )
}

export default observer(ReportedDetailsMenu)